import { NgModule } from '@angular/core';
import { PhoneNumberInputDirective } from './phone-number-input.directive';
import { PhoneNumberPipeModule } from '../../pipes/phone-number';


@NgModule({
    imports: [],
    exports: [PhoneNumberInputDirective],
    declarations: [PhoneNumberInputDirective],
    providers: [],
})
export class PhoneNumberInputModule { }
